var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.profileInfo.is_done_step)?_c('div',[(_vm.nextStep && _vm.nextStep.name === 'verify_email')?_c('resendEmail',{attrs:{"card":_vm.card}}):(_vm.nextStep && _vm.nextStep.text_step)?_c('registerStep',{attrs:{"step-data":_vm.nextStep}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }